import React from 'react';

import { CGProduct } from '../../types/shopify';
// import RouteLeavingGuard from '../Navigation/RouteLeavingGuard';
import CardConfigurerForm from './CardConfigurerForm';
import { useHistory } from 'react-router-dom';
import { CGCardConfigFormValues } from 'types/cardForm';

interface CardConfigurerProps {
  product: CGProduct;
  initialValues?: Partial<CGCardConfigFormValues>;
  initialStep?: number;
}

const CardConfigurer: React.FC<CardConfigurerProps> = ({ product, initialValues = {}, initialStep = 0 }) => {
  // const [isBlocking, setIsBlocking] = useState(true);
  const history = useHistory();
  return (
    <div>
      {/* <RouteLeavingGuard
        when={isBlocking} // Def blocking
        shouldBlockNavigation={(path) => {
          d('tryingToNavigateTo', path);
          if (isBlocking) return true;
          return true;
        }}
      /> */}
      <CardConfigurerForm
        onClose={() => history.go(-1)}
        onSuccess={() => {
          // setIsBlocking(false);
          history.push('/cart');
        }}
        product={product}
        initialValues={initialValues}
        initialStep={initialStep}
      />
    </div>
  );
};

export default CardConfigurer;
